import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import TabComponent from "./CustomTabComponent";
import Commentary from "./Commentary";
import LiveChat from "./LiveChat";
// import Gallery from "./Gallery";
import useSocketEvents from "../../../../../../hooks/useSocketEvents";
import { SelectTabStyles as styles } from "./chat.tailwind";
import { LIVE_CHAT_CONSTANTS } from "../../../../../../lib/constants/websocketConstants";
import { SocketContext } from "../../../../../../context/socket";
import { appendMedia, appendMessage, deleteLiveMessage, getLiveGameMediaList, getMessages, pushToLeaderboard, updateLeaderboard, updateLiveMessage } from "../../../../../../redux/slices/liveGameSlice";
import { updateUserPoints } from "../../../../../../redux/slices/rewardSlice";
import { connect, useDispatch, useSelector } from "react-redux";
import { getAllLiveGameActionsByGameId, updateGameDetailsReducer } from "../../../../../../redux/slices/scorerSlice";
import { tabs } from "./livechat.data";
// import { PAGE_SIZE } from "./livechat.data";
import { FETCH_POLL_TYPE, LIVE_GAME_CHAT_CONTENT_TYPE } from "../../../../../../lib/constants/globalConstant";
import { addNewUpdatedPoll, createNewLivePoll, deleteOldLivePoll, getLivePolls, updateLivePollGameIds, updateLivePollsStateOnSubmit, updateTotalLivePollsStateOnSubmit } from "../../../../../../redux/slices/earnPointSlice";
import LivePollSection from "./LivePollSection";
import Zones from "./Zones";
import MobileTabsComponent from "./MobileTabsComponent";
import TotalRewardPoints from "./TotalRewardPoints";
import { showSuccessSnackbar } from "../../../../../../redux/slices/snackbarSlice";
import LiveChatSkeleton from "./Skeleton/LiveChatSkeleton/LiveChatSkeleton";
import PollSkeleton from "../../../../shared/Skeletons/PollSkeleton/PollSkeleton";
import CommentarySkeleton from "./Skeleton/CommentarySkeleton/CommentarySkeleton";

export const LiveChatSection = ({ gameId, handleReplayCommentary, replayedMessage, tabValue, setTabValue, getChatMessages, getChatMedia, addNewMedia, updateMessage, deleteMessage, addNewMessage, handleNewCommentary, addToLeaderboard, updateInLeaderboard, updatePoints, updateGameDetailsReducer, triggerPointsAnimation, getCommentary, getLiveActivePolls, updateLivePolls, updateTotalVotes, createLivePoll, deleteLivePoll, updateLivePollGames, addUpdatedPoll }) => {
  const apiDataRef = useRef(false);
  const { socket } = useContext(SocketContext);
  const dispatch = useDispatch();
  

  const { user } = useSelector((state) => state.user);
  const { messages, liveGameMedia, messageLoading } = useSelector((state) => state.liveGame);
  const { pageNumber } = liveGameMedia;
  const [pointQueue, setPointQueue] = useState([]); //Queue to handle incoming points
  const [mediaMessages, setMediaMessages] = useState([]);
  // const [finalAppliedFilters, setFinalAppliedFilters] = useState([]);
  // const [totalPages, setTotalPages] = useState(0);

  // handleTabChange function
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Handle adding a new message
  const handleNewMessage = (message) => {
    if (message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.IMAGE || message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.VIDEO) {
      addNewMedia(message);
      return
    } else {
      addNewMessage(message);
    }
  };

  const handleUpdateMessage = ({ messageId, attachmentURLs }) => {
    // if (message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.IMAGE || message?.contentType === LIVE_GAME_CHAT_CONTENT_TYPE.VIDEO) {
    //   addNewMedia(message);
    //   return
    // } else {
    //   addNewMessage(message);
    // }
    // console.log(attachmentURLs);
    updateMessage({ messageId, attachmentURLs });
  }

  const handleDeleteMessage = ({ messageId }) => {
    // addNewMessage(message);
    deleteMessage({ messageId })
  }

  // Update user points
  const handleUserPointsAdded = ({ points }) => {
    setPointQueue((prevQueue) => [...prevQueue, points]);
  }

  // Add to leaderboard
  const handleAddToLeaderboard = ({ details }) => {
    addToLeaderboard(details);
  }

  // Update leaderboard
  const handleUpdateLeaderboard = ({ details }) => {
    updateInLeaderboard(details);
  }

  const handleUpdateUserPoints = ({ userTotalAvailablePoints, userTotalEarnedPoints }) => {
    updatePoints({ userTotalAvailablePoints, userTotalEarnedPoints });
  }

  const handleUpdateScores = ({ homeTeamScore, awayTeamScore }) => {
    updateGameDetailsReducer({ homeTeamScore, awayTeamScore });
  }

  const handleUpdateVotes = ({ pollId, pollOptions }) => {
    updateLivePolls({ pollId, update: pollOptions })
  }

  const handleUpdateTotalVotes = ({ totalVotesDetail, pollId }) => {    
    updateTotalVotes({ pollId, totalVotesDetail: totalVotesDetail });
  }

  const handleUpdateBasicDetails = ({ pollId, updatedFields }) => {
    // console.log(updatedFields)
    updateLivePolls({ pollId, update: updatedFields })
  }

  const handleUpdatePollStatus = ({ pollId, status }) => {
    updateLivePolls({ pollId, update: { status } })
  }

  const handleUpdatePollGame = ({ pollId, poll }) => {
    updateLivePollGames({ pollId, poll, currentGameId: gameId, userId: user?.userDetails?._id })
  }

  const handleAddPollIfNotPresent = ({ pollId, poll }) => {
    addUpdatedPoll({ pollId, poll });
    // dispatch(showSuccessSnackbar({
    //   title: 'New Poll Created!',
    //   position: { vertical: 'bottom', horizontal: 'left' } 
    // }))
  }

  const handleCreateNewPoll = ({ poll }) => {
    createLivePoll({ poll })

    dispatch(showSuccessSnackbar({
      title: 'New Poll Created!',
      position: { vertical: 'bottom', horizontal: 'left' } 
    }))
  }

  const handleDeletePoll = ({ pollId }) => {
    deleteLivePoll({ pollId })
  }

  // Listen for socket-events
  useSocketEvents(socket,
    useMemo(() => ({
      [LIVE_CHAT_CONSTANTS.NEW_MESSAGE]: handleNewMessage,
      [LIVE_CHAT_CONSTANTS.UPDATE_MESSAGE]: handleUpdateMessage,
      [LIVE_CHAT_CONSTANTS.DELETE_MESSAGE]: handleDeleteMessage,
      [LIVE_CHAT_CONSTANTS.ADD_NEW_COMMENTARY]: handleNewCommentary,
      [LIVE_CHAT_CONSTANTS.USER_POINT_ADDED]: handleUserPointsAdded,
      [LIVE_CHAT_CONSTANTS.INSERTED_LEADERBOARD]: handleAddToLeaderboard,
      [LIVE_CHAT_CONSTANTS.UPDATED_LEADERBOARD]: handleUpdateLeaderboard,
      [LIVE_CHAT_CONSTANTS.UPDATED_USER_POINTS]: handleUpdateUserPoints,
      [LIVE_CHAT_CONSTANTS.UPDATE_SCORE]: handleUpdateScores,
      [LIVE_CHAT_CONSTANTS.UPDATE_POLL]: handleUpdateVotes,
      [LIVE_CHAT_CONSTANTS.UPDATE_POLL_TOTAL_VOTES]: handleUpdateTotalVotes,
      [LIVE_CHAT_CONSTANTS.UPDATE_POLL_BASIC_DETAILS]: handleUpdateBasicDetails,
      [LIVE_CHAT_CONSTANTS.UPDATE_POLL_STATUS]: handleUpdatePollStatus,
      [LIVE_CHAT_CONSTANTS.UPDATE_POLL_GAME_ID]: handleUpdatePollGame,
      [LIVE_CHAT_CONSTANTS.ADD_POLL_IF_NOT_PRESENT]: handleAddPollIfNotPresent,
      [LIVE_CHAT_CONSTANTS.CREATE_POLL]: handleCreateNewPoll,
      [LIVE_CHAT_CONSTANTS.DELETE_POLL]: handleDeletePoll,
      [LIVE_CHAT_CONSTANTS.PUSH_AUTOMATED_POLL]: handleCreateNewPoll,
      [LIVE_CHAT_CONSTANTS.PULL_AUTOMATED_POLL]: handleDeletePoll,
    }), [handleNewMessage, handleNewCommentary, handleUserPointsAdded, handleAddToLeaderboard, handleUpdateLeaderboard, handleUpdateUserPoints, handleUpdateScores])
  );

  const callApi = useCallback(async () => {
    if (apiDataRef.current) return;
    apiDataRef.current = true;
    
    const data = {
      gameId
    }
    getChatMessages(data);
    getChatMedia({ ...data, page: '1' });
    // getCommentary({...data });
    getCommentary({...data, reverse: true });

    const pollsData = {
      fetchType: FETCH_POLL_TYPE.LIVE_GAME,
      gameId
    }
    getLiveActivePolls(pollsData);
  }, [gameId]);

  useEffect(() => {
    callApi()
  }, [callApi]);

  useEffect(() => {
    // Process the pointQueue when it's updated
    if (pointQueue.length > 0) {
      const currentPoint = pointQueue[0]; // Get the first point in the queue
      triggerPointsAnimation(currentPoint); // Trigger the animation

      // Remove the processed point from the queue after the animation duration
      const timeoutId = setTimeout(() => {
        setPointQueue((prevQueue) => prevQueue.slice(1)); // Remove the first point
      }, 1000); // Match the animation duration

      return () => clearTimeout(timeoutId);
    }
  }, [pointQueue]);

  useEffect(() => {
    if (!liveGameMedia) return;

    // setTotalPages(Math.ceil(liveGameMedia?.totalRecords / PAGE_SIZE));

    // if ((finalAppliedFilters?.length > 0 && pageNumber === 1)) {
    //   setMediaMessages(liveGameMedia?.mediaList);
    // }

    if (pageNumber > 1) {
      setMediaMessages([...mediaMessages, ...(liveGameMedia?.mediaList || [])])
    } else {
      setMediaMessages(liveGameMedia?.mediaList);
    }

  }, [liveGameMedia]);

  return (
    <div className={styles.sectionContainer}>
      {/* Sticky TabComponent */}
      <TabComponent tabValue={tabValue} handleTabChange={handleTabChange} />

      {/* Scrollable content area */}
      <div className={styles.scrollableContent} style={{ scrollbarWidth: "none", borderRadius: tabValue === 0 ? ("0px 10px 10px 10px") : tabValue === (tabs.length - 1) ? ("10px 0px 10px 10px") : "10px" }}>
        {messageLoading ? (
          <>
          {tabValue === 1 && 
            <div className="flex flex-col h-full w-full">
              <LiveChatSkeleton />
            </div>
          }
          {tabValue === 2 && 
            <div className="flex flex-col gap-3 overflow-y-auto pr-2 pt-1 h-full screen-500:max-h-[380px] md:max-h-[450px] sm:pt-2 lg:pt-0">
              <PollSkeleton isLiveGame={true} />
            </div>
          }
          {tabValue === 0 && 
            <div className="flex flex-col h-full w-full overflow-y-auto pr-2">
              <CommentarySkeleton />
            </div>
          }
          </>
        ) : (
          <>
            {tabValue === 1 && (
              <LiveChat
                gameId={gameId}
                messages={messages}
                handleNewMessage={handleNewMessage}
                replayedMessage={replayedMessage}
                handleReplayCommentary={handleReplayCommentary}
                socket={socket}
              />
            )}
            {tabValue === 2 && (
              <LivePollSection
                gameId={gameId}
              />
            )}
            {tabValue === 0 && (
              <Commentary
                messages={messages}
                replayedMessage={replayedMessage}
                handleReplayCommentary={handleReplayCommentary}
              />
            )}
            {tabValue === 3 && (
              <Zones
                gameId={gameId}
              />
            )}
            {tabValue === 4 && (
              <TotalRewardPoints />
            )}
            {/* {tabValue === 3 && (
              <Gallery
                gameId={gameId}
                mediaMessages={mediaMessages}
                finalAppliedFilters={finalAppliedFilters}
                pageNumber={pageNumber}
                totalPages={totalPages}
                setMediaMessages={setMediaMessages}
                handleNewMessage={handleNewMessage}
                setFinalAppliedFilters={setFinalAppliedFilters}
              />
            )} */}
          </>
        )}
      </div>

      <MobileTabsComponent tabValue={tabValue} handleTabChange={handleTabChange} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getChatMessages: (data) => dispatch(getMessages(data)),
  getChatMedia: (data) => dispatch(getLiveGameMediaList(data)),
  getCommentary: (data) => dispatch(getAllLiveGameActionsByGameId(data)),
  addNewMessage: (data) => dispatch(appendMessage(data)),
  updateMessage: (data) => dispatch(updateLiveMessage(data)),
  deleteMessage: (data) => dispatch(deleteLiveMessage(data)),
  addNewMedia: (data) => dispatch(appendMedia(data)),
  updateInLeaderboard: (data) => dispatch(updateLeaderboard(data)),
  addToLeaderboard: (data) => dispatch(pushToLeaderboard(data)),
  updatePoints: (data) => dispatch(updateUserPoints(data)),
  updateGameDetailsReducer: (data) => dispatch(updateGameDetailsReducer(data)),
  getLiveActivePolls: (data) => dispatch(getLivePolls(data)),
  updateLivePolls: (data) => dispatch(updateLivePollsStateOnSubmit(data)),
  updateTotalVotes: (data) => dispatch(updateTotalLivePollsStateOnSubmit(data)),
  updateLivePollGames: (data) => dispatch(updateLivePollGameIds(data)),
  createLivePoll: (data) => dispatch(createNewLivePoll(data)),
  deleteLivePoll: (data) => dispatch(deleteOldLivePoll(data)),
  addUpdatedPoll: (data) => dispatch(addNewUpdatedPoll(data)),
});

export default connect(null, mapDispatchToProps)(React.memo(LiveChatSection));
